// The one list of abbreviations that stay in capitals on every label.
// Only the real English words (it, us, un-) are left out: a label already
// written in capitals stays in capitals anyway.
// Marcel's list (ClickUp 86cah9681) plus the shipping and finance ones that
// already appear on our screens. Add a word here and every label follows.
export const ACRONYMS = [
  'ERP', 'VAT', 'CIF', 'FOB', 'ISO', 'API', 'KPI', 'ETA', 'ETD', 'BDN', 'BL', 'KYC', 'CRM', 'GL',
  'HMS', 'IMT', 'USD', 'EUR', 'GBP', 'AED', 'CHF', 'ZAR', 'SGD', 'MT', 'LSFO', 'VLSFO', 'MGO',
  'HSFO', 'LNG', 'IMO', 'ID', 'PDF', 'CSV', 'IBAN', 'SWIFT', 'BIC', 'UK', 'UAE', 'USA',
  'SLA', 'FAQ', 'URL', 'FX', 'OTP', 'SSO', 'AI', 'PO', 'HR', 'MM', 'DD', 'AP', 'AR', 'ESG', 'UBO',
  'DWT', 'LOCODE', 'YYYY', 'TBA', 'TBC', 
];

export const ACRONYM_SET = new Set(ACRONYMS);
